import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import { Link, useNavigate } from "react-router-dom";

const Footer = () => {
  const { t } = useContext(LanguageContext);

  return (
    
    <footer className="bg-gray-800 text-white text-sm py-4">
      <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row justify-between items-center">
        <div className="mb-2 sm:mb-0">
          © 2025 <span className="text-yellow-400">TeamCoin.de</span> – {t("footerTagline")}
        </div>
        <div className="flex space-x-4">          
           <Link to="/cms/impressum" className="hover:text-yellow-400">
            {t("impressum")}
          </Link>
          <Link to="/cms/datenschutz" className="hover:text-yellow-400">
            {t("datenschutz")}
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
